import { render, staticRenderFns } from "./JsTitle.vue?vue&type=template&id=225cbc83&scoped=true&"
import script from "./JsTitle.vue?vue&type=script&lang=js&"
export * from "./JsTitle.vue?vue&type=script&lang=js&"
import style0 from "./JsTitle.vue?vue&type=style&index=0&id=225cbc83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cbc83",
  null
  
)

export default component.exports